<template>
  <div class="element-box">
    <div class="table-responsive">
      <table class="table table-striped table-lightborder table-striped">
        <thead>
          <tr v-for="group in this.table_columns" v-if="mode == 'Workflow'">
            <th
              v-for="header in group"
              v-if="header.module == '' || modules.includes(header.module)"
              :rowspan="header.rowspan"
              :colspan="header.colspan"
              :class="[header.class, (header.visible == true ? 'b-r' : 'hidden')]"
            >{{header.name}}</th>
          </tr>

          <tr v-for="group in this.table_columns_rms" v-if="mode == 'RMS'">
            <th
              v-for="header in group"
              :rowspan="header.rowspan"
              :colspan="header.colspan"
              :class="[header.class, (header.visible == true ? '' : 'hidden')]"
            >{{header.name}}</th>
          </tr>
        </thead>
        <tbody v-if="mode =='Workflow'">
          <tr v-for="product in products" class="b-b">
            <td class="b-r">
              <div class="element-box-tp">
                <div class="profile-tile">
                  <a class="profile-tile-box">
                    <div class="pt-avatar-w">
                      <clazy-load :src="formatPreview(product.preview)" class="incoming-image">
                        <img :src="formatPreview(product.preview)" @error="formatPreview()" />
                        <div class="preloader" slot="placeholder">
                          <img :src="product.preview" />
                        </div>
                      </clazy-load>
                    </div>
                  </a>
                  <div class="profile-tile-meta">
                    <td>
                      <div class="product-name">{{product.item_parent_identifier}}</div>
                      <div class="product-details">
                        <span>Color: </span>
                        <strong> {{product.color || '--'}}</strong> <br />
                        <span>Brand: </span>
                        <strong>{{product.brand || '--'}}</strong>
                      </div>
                    </td>
                  </div>
                </div>
              </div>
            </td>

            <td class="b-r">
              <table class="table table-lightborder">
                <tbody>
                  <tr v-for="movement in product.movements" v-if="product.movements">
                    <td>
                      <div class="value product-name">{{movement.item_identifier}}</div>
                      <span class="sub-value">
                        <div v-if="movement.inbound_at">
                          <div v-if="movement.outbound_at" class="text-danger">Checked Out<br>{{movement.outbound_at}}</div>
                          <div v-else class="text-primary">Checked In to {{movement.location}}<br>{{movement.inbound_at}}</div>
                        </div>
                        <div v-else>No Inbound</div>
                      </span>
                    </td>
                    <td class="text-right">
                      <div class="value">{{movement.size || 'No Size'}}</div>
                      <span class="sub-value"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td class="b-r">
              <ul style="padding-left: 2px; list-style-type: none;">
                <li v-if="product.category_name">{{product.category_name}}</li>
                <li v-if="product.gender">{{product.gender}}</li>
                <li v-if="product.description">{{product.description}}</li>
              </ul>
            </td>

            <td class="b-r">
              {{product.reporting_class}}
              <div v-if="product.photodesk_session_misc && JSON.parse(product.photodesk_session_misc)['rack_id'] !== null">
                Rack ID: {{JSON.parse(product.photodesk_session_misc)['rack_id']}}
              </div>
            </td>

            <!-- <td :class="table_columns.group_1[7].visible == true ? '' : 'hidden'"> -->

              <td class="b-r" colspan="11" v-if="product.archive_at">
                <h4 class="text-center ">
                  Archived by {{ product.archive_by }}
                </h4>
              </td>

            <td colspan="2" class="b-r" v-if="modules.includes('photodesk') && !product.archive_at" >
              <table class="table table-lightborder">
                <tbody>
                  <tr
                    v-for="session in formatCompleteSessions(product)"
                    v-if="session.session != 'Copy'"
                  >
                    <td>
                      <div class="value product-name-small text-bold">  {{session.session}} Shot</div>
                      <span class="sub-value">
                        {{session.photographer}}
                        <br />
                        {{session.location}}
                        <br />
                        {{session.date}}
                      </span>
                    </td>
                    <td class="text-right">
                      <div class="value">
                        <i class="fas" :class="session.status" />
                      </div>
                      <span class="sub-value"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <!-- <td colspan="2" class="center">
              <i class="fas" :class="formatRetouchSent(product)" />
            </td> -->
            <!-- <td class="center b-r">
              <i class="fas" :class="formatRetouchReceived(product)" />
            </td> -->
            <td colspan="2" class="b-r" v-if="modules.includes('photodesk') && !product.archive_at">
              <table class="table table-lightborder">
                <tbody>
                  <tr>
                    <td>
                      <div class="value product-name-small">{{formatRetouchReceived(product).status}}</div>
                      <span class="sub-value">
                        Retoucher: {{product.retouch_agency_name}}
                      </span> <br />
                      <span class="sub-value">
                        {{formatRetouchReceived(product).status_by}}
                      </span>
                    </td>
                    <td class="text-right">
                      <div class="value">
                        <i class="fas" :class="formatRetouchReceived(product).icon" />
                      </div>
                      <span class="sub-value"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td colspan="2" v-if="modules.includes('copydesk') && !product.archive_at">
              <table class="table table-lightborder">
                <tbody>
                  <tr v-for="session in formatCopyCompleteSessions(product)">
                    <td>
                      <div class="value product-name-small">{{session.session}} Copy</div>
                      <span class="sub-value">
                        {{session.writer}}
                        <br />
                        {{session.date}}
                      </span>
                    </td>
                    <td class="text-right">
                      <div class="value">
                        <i class="fas" :class="session.status" />
                      </div>
                      <span class="sub-value"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td colspan="2" class="center b-r" v-if="modules.includes('copydesk') && !product.archive_at">
              <i class="fas" :class="formatCopyReview(product)" />
            </td>
            <td class="center b-r" v-if="modules.includes('photodesk') && !product.archive_at">
              <i class="fas" :class="formatFinalImages(product)" />
            </td>
            <td colspan="2" class="center b-r" v-if="modules.includes('copydesk') && !product.archive_at">
              <table class="table table-lightborder">
                <tbody>
                  <tr v-for="session in formatCopySubmitSessions(product)">
                    <td>
                      <div class="value product-name-small">{{session.session}} Copy</div>
                      <span class="sub-value">
                        {{session.reviewer}}
                        <br />
                        {{session.date}}
                      </span>
                    </td>
                    <td class="text-right">
                      <div class="value">
                        <i class="fas" :class="session.status" />
                      </div>
                      <span class="sub-value"></span>
                    </td>
                  </tr>

                </tbody>
              </table>
            </td>

            <!-- <td class="center b-r b-r" v-if="modules.includes('copydesk')">
              <i class="fas" :class="formatFinalCopy(product)" />
            </td> -->
            <td class="center">
              <div class="btn-group mr-1 mb-1 mt-1">
                    <router-link :to="`/productdesk/product/${product.id_product}`">
                        <a class="btn btn-primary btn-rounded text-white">View</a>
                    </router-link>
              </div>

              <div class="btn-group mr-1 mb-1 mt-1" v-if="modules.includes('reportdesk.archive') && !product.archive_at">
                <a @click="archiveProduct(product.id_product)" class="btn btn-warning btn-rounded text-dark">Archive</a>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="mode =='RMS'">
          <tr v-for="product in products">
            <td v-for="key in Object.keys(product)" v-if="!key.startsWith('id')">{{product[key]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <Modal :show="showPMModal" v-if="showPMModal == true">
      <ProductMovementModal
        slot="content"
        :product="selectedProduct"
        :productHistory="productHistory"
        @modalInterface="togglePMModal"
        :state="PMState"
      />
    </Modal>

    <Modal :show="showPCModal" v-if="showPCModal == true">
      <ProductCommentModal
        slot="content"
        :product="selectedProduct"
        :productHistory="productHistory"
        @modalInterface="togglePCModal"
        :state="PCState"
      />
    </Modal>

    <Modal :show="showAPCModal" v-if="showAPCModal == true">
      <AddProductCommentModal
        slot="content"
        :product="selectedProduct"
        @modalInterface="toggleAPCModal"
        :state="APCState"
      />
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
import ProductMovementModal from '@/components/productdesk/modals/ProductMovementModal'
import ProductCommentModal from '@/components/productdesk/modals/ProductCommentModal'
import AddProductCommentModal from '@/components/reportdesk/modals/AddProductCommentModal'
import worklistConfig from '@/mixins/worklists/config.js'

export default {
  mixins: [worklistConfig],
  props: [
    'worklistdata',
    'worklistmovements',
    'searchString',
    'columns',
    'mode',
    'modules'
  ],
  components: {
    Modal,
    ProductMovementModal,
    ProductCommentModal,
    AddProductCommentModal
  },
  methods: {
    archiveProduct (id_product) {
      this.$emit('archiveInterface', id_product)
    }
  },
  watch: {
    columns () {
      this.updateColumns()
    },
    table_columns () {},
    worklistmovements () {
      this.movements = this.worklistmovements
    },
    worklistdata () {
      this.products = this.worklistdata.hits || this.worklistdata.data
      this.formatRMSColumns(this.products[0])
    },
    searchString () {},
    productHistory () {},
    product () {},
    PMLoading () {}
  }
}
</script>

<style scoped>
.break-line{
    display: block;
    margin-bottom: 2px;
}
.break-line::after{
    content: "\a";
    white-space: pre;
}
.property-side-features .feature {
  padding: 5px 10px;
}
.hidden {
  display: none;
}
td {
  white-space: nowrap;
}
td.wrap {
  white-space: normal;
}
td.center {
  text-align: center;
}
.clickable {
  color: blue;
  cursor: pointer;
}
.element-box {
  display: flex;
  flex: 1;
  overflow-x: scroll;
  overflow-y: scroll;
}
.product-flags {
  margin-right: 5px;
}
.Yes-Circle::before {
  content: "\f058";
  color: #75da62 !important;
}

.No-Circle::before {
  content: "\f057";
  color: #ed1c24 !important;
}

.Skipped-Circle::before {
  content: "\f05e";
}

.Skipped::before {
  content: "\f05e";
}

.Yes-text {
  color: #75da62 !important;
  font-weight: 500;
}
.Yes::before {
  content: "\f00c";
  color: #75da62 !important;
}
.No-text {
  color: #ed1c24 !important;
  font-weight: 500;
}
.No::before {
  content: "\f00d";
  color: #ed1c24 !important;
}
.NA::before {
  content: "\f068";
}
.Pending-text {
  color: #ffa000 !important;
  font-weight: 500;
}
.Pending::before {
  content: "\f12a";
  color: #ffa000 !important;
}
.Styling::before {
  content: "\f0d1";
  color: #000 !important;
}
.Comment::before {
  content: "\f075";
  color: #000 !important;
}
.ForceComplete::before {
  content: "\f560";
  color: #000 !important;
}
.profile-tile .pt-avatar-w {
  border-radius: 0px;
}
.profile-tile .profile-tile-box {
  padding: 0.5rem;
  width: 80px;
}
.profile-tile .profile-tile-meta ul {
  font-size: 13px;
}
.profile-tile .profile-tile-meta {
  padding-left: 10px;
}
.profile-tile .profile-tile-meta ul strong {
  margin-left: 0px;
}
.profile-tile {
  border-bottom: 0px;
  padding-bottom: 0rem;
  margin-bottom: 0rem;
}
.profile-tile .profile-tile-meta ul .clickable-link strong {
  color: #047bf8 !important;
  cursor: pointer;
}

.order-box {
  padding: 30px;
}

.order-box .order-details-box {
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin-bottom: 20px;
  -webkit-box-align: center;
  align-items: center;
}

.order-box .order-details-box .order-main-info span {
  display: block;
  color: #adb5bd;
  line-height: 1.3;
}

.order-box .order-details-box .order-main-info strong {
  display: block;
  font-size: 1.5rem;
  line-height: 1.3;
}

.order-box .order-details-box .order-sub-info span {
  display: block;
  color: #adb5bd;
  line-height: 1.3;
  font-size: 0.775rem;
}

.order-box .order-details-box .order-sub-info strong {
  display: block;
  font-size: 0.9rem;
  line-height: 1.3;
}

.order-box .order-controls {
  background-color: #fff7ea;
  border: 1px solid #e9d9c1;
  padding: 10px;
  margin-bottom: 20px;
}

.order-box .order-controls .form-group {
  margin-right: 15px;
  padding-right: 15px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}

.order-box .order-controls .form-group label {
  margin-right: 5px;
}

.order-box .order-controls .form-group:last-child {
  border-right: none;
  margin-right: 0px;
  padding-right: 0px;
  margin-left: auto;
}

.order-box .order-items-table {
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.order-box .order-items-table .product-image {
  width: 70px;
  height: 70px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}

.product-name {
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.3;
}

.product-name-small {
  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1.3;
}

.order-box .order-items-table .product-remove-btn {
  color: #e08989;
  font-size: 16px;
}

.product-details {
  color: #adb5bd;
  font-size: 0.8rem;
}

.product-details strong {
  color: #3e4b5b;
}

.product-details .color-box {
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 10px;
}

.order-box .order-items-table .product-price {
  font-weight: 500;
  font-size: 1.25rem;
}

.order-box .order-items-table .quantity-input .input-group-text {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.order-box .order-items-table .quantity-input .form-control {
  -webkit-box-flex: 0;
  flex: 0 0 45px;
  text-align: center;
  font-weight: 500;
}

.order-box .order-section-heading {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.b-r {
    border-right: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.b-b {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
</style>
